'use strict';
angular
  .module('metabuyer')
  .directive('grnPanel',function($uibModal) {
    return{
      restrict: 'A',
      scope: true,
      link: function(scope, element, attrs) {

        var panel = function(grn_id, selectedPo) {

          var modalInstance = $uibModal.open({
            templateUrl: 'components/grn/grnTemplate.html',
            backdrop: 'static',
            keyboard: false,
            controller: 'grnCtrl',
            scope: scope,
            size: "lg",
            resolve: {
              grn: function($q, getGRN){
                var defered = $q.defer();
                if(!grn_id){
                  defered.resolve({});
                  return defered.promise;
                }

                getGRN.get({id: grn_id},
                  function(resource){
                    if(!!resource && !!resource.content && !!resource.content.data){
                      defered.resolve(resource.content.data);
                    }else{
                      defered.resolve({});
                    }
                  }, function(error){
                    defered.resolve({});
                  });

                return defered.promise;
              },
              po: function(){
                return selectedPo;
              }
            }
          });
        };

        //loading the panel to comment
        scope.showGRNInfo = function(grn_id, selectedPo) {
          panel(grn_id, selectedPo);
        };
      }
    };
  });
